import useToastedMutation from '../../../ReactQuery/useToastedMutation';
import { post } from '../../../redux/api';

/**
 * Resends the email MFA code during login via `POST /api/auth/mfa/email/resend-login`. Toasts on success so the
 * user gets feedback that a new code is on the way; failures surface to the caller so it can distinguish a dead
 * pending-MFA session (restart the flow) from a retryable transient error (toast and stay put).
 */
export function useResendEmailMfa() {
  return useToastedMutation({
    mutationFn: async () => {
      await post<void, void>('/api/auth/mfa/email/resend-login', undefined);
    },
    successToastMessage: 'New code sent',
  });
}
